import { datetime, formatFileSize } from "../../utils";
import I18n from "../../I18n";
import { getFileStatus } from "../../utils/dataFileStage";

const getFileTypeValue = (fileType) =>
    fileType?.toLowerCase() === "unknown" ? I18n.translate`unknown` : fileType;

const getOriginStatusCell = (originStatus) => {
    const statusKey = originStatus || "unknown";
    const { color, statusFamily } = getFileStatus(statusKey);

    return {
        severity: 4,
        value: I18n.translate`${statusKey}`,
        label: I18n.translate`${statusKey}`,
        family: statusFamily || "text",
        color,
    };
};

const mapCard = (json) => {
    const {
        fileId,
        deletedBy,
        deletedAt,
        fileName,
        fileType,
        uploadedAt,
        fileSizeDecompress,
        originStatus,
    } = json;
    return [
        [
            {
                labels: ["id"],
                value: fileId,
                type: "string",
                align: "align-left",
                basis: "10%",
            },
        ],
        [
            {
                labels: ["fileName"],
                value: fileName,
                type: "string",
                align: "align-left",
                basis: "30%",
            },
        ],
        [
            {
                labels: ["fileType"],
                value: getFileTypeValue(fileType),
                type: "string",
                align: "align-left",
                basis: "15%",
            },
        ],
        [
            {
                value: getOriginStatusCell(originStatus),
            },
        ],
        [
            {
                labels: ["fileSizeDecompress"],
                value: formatFileSize(fileSizeDecompress),
                type: "number",
                align: "align-left",
                basis: "12%",
                mobileHidden: true,
            },
        ],
        [
            {
                labels: ["uploaded"],
                value: uploadedAt ? datetime(uploadedAt) : "N/A",
                type: "datetime",
                align: "align-left",
                basis: "15%",
                mobileHidden: true,
            },
        ],
        [
            {
                labels: ["deletedBy"],
                value: deletedBy,
                type: "string",
                align: "align-left",
                basis: "15%",
            },
        ],
        [
            {
                labels: ["deletedAt"],
                value: datetime(deletedAt),
                type: "date",
                align: "align-left",
                basis: "15%",
            },
        ],
    ];
};

const mapper = (json, card) => {
    return {
        ...json,
        id: json.fileId,
        name: json.fileName,
        shortName: json.fileName,
        card: card ? mapCard(json) : [],
    };
};

const header = [
    { label: ["Id"], align: "left", columnName: "fileId", basis: "10%" },
    { label: ["File Name"], align: "left", columnName: "fileName", basis: "30%" },
    { label: ["File Type"], align: "left", columnName: "fileType", basis: "15%" },
    {
        label: ["origin status"],
        align: "left",
        columnName: "originStatus",
        basis: "12%",
        type: "status",
    },
    {
        label: ["File Size"],
        align: "left",
        columnName: "file_size_decompress",
        basis: "12%",
        mobileHidden: true,
    },
    {
        label: ["Uploaded at"],
        align: "left",
        columnName: "uploaded_at",
        basis: "15%",
        mobileHidden: true,
    },
    {
        label: ["Deleted By"],
        align: "left",
        columnName: "deletedBy",
        basis: "15%",
    },
    {
        label: ["Deleted At"],
        align: "left",
        columnName: "deleted_at",
        basis: "15%",
    },
];

const deletefilelogsMapper = {
    map: mapper,
    header,
};

export default deletefilelogsMapper;
